<template>
  <div class="add-account-page page" :class="{ 'step-login': activeStep === 1, 'step-finish': activeStep === 3 }">
    <el-steps :active="activeStep" align-center finish-status="success" style="display:none;">
      <el-step title="Step 1" description="Security &amp; Privacy">
      </el-step>
      <el-step title="Step 2" description="Add The Account"></el-step>
      <el-step title="Step 3" description="Configure Settings"></el-step>
      <el-step title="Step 4" description="Review &amp; Save"></el-step>
    </el-steps>
    
    <!-- <el-divider></el-divider> -->

    <div v-if="activeStep === 0" class="step security-step">
      <div class="page-header">
        <h1 class="title">Security Checkup</h1>
        <p class="subtitle">
          Review your accounts and resolve any issues you might be having with them
        </p>
      </div>
      
      <el-card class="card-dialog">
        <div class="body">
          <div class="step step-1">
            <div class="title">
              We take account security super seriously.
            </div>
            <div class="description">
              Because of this, we don't save your login credentials in the app or on our servers.
            </div>
          </div>
          <div class="step step-2">
            <div class="title">
              You log in directly on Instagram, with your own computer, and on your own internet connection.
            </div>
            <div class="description">
              We don't know your username and password, and we don't want to know.
            </div>
          </div>
          <div class="step step-3">
            <div class="title">
              Any application or service that asks you for your username and password is probably a scam and should be avoided.
            </div>
            <div class="description">
              Okay. Now that we got that, in order to use this app you must first agree to our <a @click="openTerms">Terms &amp; Conditions</a>.
            </div>
          </div>
        </div>
        <div class="footer">
          <el-checkbox v-model="agreedTOS">I have read and agree to the Terms &amp; Conditions located on Likezoid.com.</el-checkbox>
          <el-button v-if="activeStep === 0" :disabled="!agreedTOS" type="primary" @click="activeStep = 1">Agree &amp; Continue</el-button>
        </div>
      </el-card>
    </div>

    <div v-loading="loginLoading" v-if="activeStep === 1" class="step login-step">
      <div class="section-header">
        <span class="icon">
          <img src="../assets/img/logo.svg"/>
        </span>
        <h2 class="title">Add or update an Instagram Account</h2>
        <p class="subtitle">
          Awesome! Now we just need to have you log in through Instagram's official website Simply click the button below to continue.
        </p>
      </div>
      <el-button type="primary" @click.prevent="openInstagram()">Login to Instagram</el-button>

      <div class="step-indicators">
        <div class="step-indicator active"></div>
        <div class="step-indicator"></div>
        <div class="step-indicator"></div>
      </div>
    </div>

    <div v-if="activeStep === 2" class="step config-step">
      <div class="section-header">
        <span class="icon">
          <img src="../assets/img/logo.svg"/>
        </span>
        <h2 class="title">You're almost done!</h2>
        <p class="subtitle">
          Now let's make sure you're getting targeted likes.<br>
          Fill out the configuration form below and try to make sure it's as accurate as possible. <br>
          The more accurate your configuration is, the better results you'll receive.<br>
        </p>
      </div>

      <el-row>
        <el-col :span="14" :offset="5">
          <el-form ref="form" label-width="140px" label-position="left">
            <el-form-item label="Gender">
              <el-select value="" v-model="gender" placeholder="Select a gender">
                <el-option
                  v-for="g in genders"
                  :key="g.id"
                  :label="g.name"
                  :value="g.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Preferred language">
              <el-select value="" v-model="language" placeholder="Choose a language" filterable>
                <el-option
                  v-for="lang in languages"
                  :key="languages.indexOf(lang)"
                  :label="lang"
                  :value="lang">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Account Timezone">
              <el-select value="" v-model="timezone" placeholder="Choose a timezone" filterable :filter-method="filterTimezones">
                <el-option
                  v-for="tz in filteredTimezones"
                  :key="tz.timeZoneId"
                  :label="tz.name"
                  :value="tz.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-button :disabled="!(gender && language && timezone)" type="primary" @click.prevent="activeStep = 3">Apply Settings</el-button>

      <div class="step-indicators">
        <div class="step-indicator"></div>
        <div class="step-indicator active"></div>
        <div class="step-indicator"></div>
      </div>
    </div>

    <div v-if="activeStep === 3" class="step finish-step">
      <div class="section-header">
        <span class="icon">
          <img src="../assets/img/logo.svg"/>
        </span>
        <h2 class="title">Congrats!</h2>
        <p class="subtitle">
          Cool, it looks like you were able to successfully login to your account.<br><br>
          You should start earning Gold shortly - sometimes it can take a bit to get started, so please be patient.
        </p>
      </div>
      <el-button type="primary" @click.prevent="navigate(Pages.Accounts)">Finish up</el-button>

      <div class="step-indicators">
        <div class="step-indicator"></div>
        <div class="step-indicator"></div>
        <div class="step-indicator active"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Genders } from '@/constants/genders'
import { Timezones } from '@/constants/timezones'
import { Languages } from '@/constants/languages'
import { BridgeAPI } from '../bridge';

export default {
  name: 'AddAccount',
  data () {
    return {
      timezones: Timezones,
      languages: Languages,
      genders: Genders,

      activeStep: 0,
      agreedTOS: false,
      gender: '',
      language: '',
      timezone: null,
      filteredTimezones: [],

      loginLoading: false,
      isIgWindowOpen: false,
      // debug
      igUser: false,
      visible: true,

      accountObject: {},

    }
  },
  computed: {
    ...mapGetters([
      'Pages'
    ])
  },
  created () {
    this.filteredTimezones = this.timezones
    // This is called when the user hits "Cancel" within the Instagram modal window, which closes the app.
    window.addEventListener('igWindowClosed', this.onIgWindowClosed.bind(this))
    // this.$on('openAddAccountDialog', this.openDialog)
  },
  methods: {
    openTerms () {
      const url = process.env.VUE_APP_SITE_TOS;
      BridgeAPI.openLink(url);
    },
    ...mapActions({
      loadAccounts: 'loadAccounts',
      navigate: 'changePage',
      setActiveAccountByUserId: 'setActiveAccountByUserId',
    }),
    onIgWindowClosed (info) {
      this.isIgWindowOpen = false;
      this.loginLoading = false;

      // Get the users' profile info from the ipcRenderer
      if (info && info.detail) {
        if (info.detail.user_id && info.detail.profile && info.detail.profile.username) {
          BridgeAPI.sendIdentify();
          // Load up the accounts and set the active user
          this.loadAccounts();
          this.setActiveAccountByUserId(info.detail.user_id);
          this.accountObject = info.detail;
          this.activeStep = 3
        }
      }

    },
    checkBridge () {
      if (!window.bridge.native) {
        throw new Error(`Native bridge wasn't found. Try again, bro. :)`)
      }
    },
    async getInstagramUser() {
      //console.log('Fetching instagram user...')
      try {
        let res = await window.bridge.native.InstagramAPI.fetchUser('9gag');
        if (res.data) {
          if (res.data.graphql && res.data.graphql.user) {
            let user = res.data.graphql.user;
            if (user.is_private) {
              // Show a dialog telling them they need to update their profile to public
              // Add a "Continue" button on that dialog component that scrapes again
            } else {
              this.igUser = user;
            }
          }
        }
        // console.log(res.data);
      } catch (error) {
        // console.error(error);
      }
    },
    openInstagram () {
      this.checkBridge()
      this.loginLoading = true;
      window.bridge.native.InstagramWindow.openInstagramWindow().then(() => {
        this.isIgWindowOpen = true;
      })
    },
    filterTimezones (v) {
      if (v.length) {
        this.filteredTimezones = this.timezones.filter(t => t.name.toLowerCase().includes(v.toLowerCase()))
      } else {
        this.filteredTimezones = this.timezones
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-account-page {
  .page-header .subtitle {
    width: 342px;
  }

  &.step-login,
  &.step-finish {
    > * {
      position: relative;
      z-index: 100;
    }

    &:after {
      content: '';
      position: absolute;
    left: 50%;
      bottom: 0;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 0;
    }
  }

  &.step-login:after {
    margin-left: -122px;
    width: 244px;
    height: 295px;
    background-image: url('../assets/img/view/account/login.svg');
  }

  &.step-finish:after {
    margin-left: -312.5px;
    width: 643px;
    height: 281px;
    background-image: url('../assets/img/view/account/finish.svg');
  }
}

.step {
  text-align: center;
  
  &.security-step {
    .el-card.card-dialog {
      .body {
        display: flex;
        justify-content: center;

        .step {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;

          &:before {
            content: '';
            display: block;
            background-size: 100%;
            background-position: center;
            background-repeat: no-repeat;
          }

          &.step-1:before {
            width: 49px;
            height: 50px;
            background-image: url('../assets/img/view/account/step/step-1.svg');
          }

          &.step-2:before {
            width: 40px;
            height: 50px;
            background-image: url('../assets/img/view/account/step/step-2.svg');
          }

          &.step-3:before {
            width: 49px;
            height: 50px;
            background-image: url('../assets/img/view/account/step/step-3.svg');
          }

          .title {
            margin-top: 16px;
            font-weight: 600;
          }

          .description {
            margin-top: 12px;
          }

          .title, .description {
            font-size: 14px;
          }

          &:not(:first-child) {
            margin-left: 74px;
          }
        }
      }

      .footer {
        display: flex;
        padding-left: 35px;
        justify-content: space-between;
        align-items: center;
      }
    }
  }

  &.config-step .el-row {
    margin-bottom: 16px;
  }

  .step-indicators {
    margin-top: 36px;

    .step-indicator {
      display: inline-block;
      width: 5px;
      height: 5px;
      background: #6F748e;
      border-radius: 2.5px;
      opacity: 0.3;

      &.active {
        background: #e88473;
        opacity: 1;
      }

      &:not(:first-child) {
        margin-left: 20px;
      }
    }
  }
}
</style>
